/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MessagesSummaryAliases {
  AVATAR_0 = 'avatar-0',
  DECK_MESSAGES = 'deck-messages',
  FETCH_MESSAGES = 'fetch-messages',
  FIELD_0 = 'field-0',
  HPMS_CUSTOM_CARD_MESSAGES = 'hpms-custom-card-messages',
  LAYOUT_0 = 'layout-0',
  MAPPER_0 = 'mapper-0',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  TEXT_0 = 'text-0',
}
export { MessagesSummaryAliases };
